export const IST = "Asia/Kolkata";
const IST_MS = 19800000;

// Every toLocale* call in the app renders in IST unless a timeZone is passed explicitly.
export const installIstDates = () => {
  ["toLocaleString", "toLocaleDateString", "toLocaleTimeString"].forEach((m) => {
    const orig = Date.prototype[m];
    if (orig.__ist) return;
    const patched = function (loc, opts) { return orig.call(this, loc, { ...(opts || {}), timeZone: (opts && opts.timeZone) || IST }); };
    patched.__ist = true;
    Date.prototype[m] = patched; // eslint-disable-line no-extend-native
  });
};

// "YYYY-MM-DDTHH:mm" entered as IST -> UTC ISO string
export const istInputToIso = (v) => new Date(`${v.length === 16 ? `${v}:00` : v}+05:30`).toISOString();
export const istToday = () => new Date(Date.now() + IST_MS).toISOString().slice(0, 10);
export const istDayStart = (offset = 0, ymd = istToday()) => new Date(new Date(`${ymd}T00:00:00+05:30`).getTime() + offset * 86400000);
export const istWeekday = () => new Date(Date.now() + IST_MS).getUTCDay();
export const istHour = () => new Date(Date.now() + IST_MS).getUTCHours();
export const istYmd = (d) => new Date(d.getTime() + IST_MS).toISOString().slice(0, 10);
